module.exports = __webpack_public_path__ + "static/media/cq_montante.c2ead918.svg";